module.exports = __webpack_public_path__ + "img/icon2.0ba4fd46.png";